// Hợp đồng API của module `profiles` — «Hành chính: Hồ sơ nhân sự».
//
// Ba mức quyền, do chủ dự án chốt ngày 09/09/2026:
//   · Mọi người    — xem và SỬA hồ sơ CỦA CHÍNH MÌNH, không thấy hồ sơ ai khác.
//   · Trưởng phòng — xem thêm hồ sơ người TRONG PHÒNG MÌNH, nhưng CHỈ phần LIÊN LẠC (điện
//                    thoại, email cá nhân, người báo tin khẩn cấp). CCCD, ngày sinh, quê quán,
//                    địa chỉ, hợp đồng đều KHÔNG gửi về cho họ.
//   · Giám đốc     — xem và sửa tất cả.
//
// Lọc ở MÁY CHỦ chứ không phải ở giao diện: ẩn bớt ở trình duyệt chỉ là lớp sơn, mở DevTools
// ra là đọc hết. Các danh sách trường dưới đây gửi cho web CHỈ để vẽ đúng cột/ô — máy chủ
// không bao giờ tin vào chúng ở phía trình duyệt.
import { z } from 'zod';
/** Mọi ô của một hồ sơ, theo ĐÚNG thứ tự kiểm tra của máy chủ (ô sai đầu tiên là ô bị báo). */
export const EMPLOYEE_PROFILE_FIELDS = [
    'fullName',
    'birthDate',
    'gender',
    'nationalId',
    'hometown',
    'address',
    'phone',
    'personalEmail',
    'emergencyContactName',
    'emergencyContactRelation',
    'emergencyContactPhone',
    'joinedOn',
    'jobTitle',
    'contractType',
    'contractEndDate',
    'employmentStatus',
    'notes',
];
/**
 * Phần Trưởng phòng được nhìn của người khác trong phòng. Danh sách này chỉ được PHÉP NGẮN
 * LẠI, đừng nới ra mà không hỏi chủ dự án — mỗi tên thêm vào là một mục thông tin cá nhân lộ
 * ra thêm một lớp người.
 *
 * `fullName` KHÔNG nằm trong đây: đó là họ tên đầy đủ trên CCCD. Tên để nhận ra người đã có
 * sẵn ở `displayName` (tên hiển thị của tài khoản) — thứ mà ai có quyền nhìn người khác cũng
 * đã đọc được ở Cài đặt → Thành viên.
 */
export const EMPLOYEE_PROFILE_CONTACT_FIELDS = [
    'phone',
    'personalEmail',
    'emergencyContactName',
    'emergencyContactRelation',
    'emergencyContactPhone',
];
/**
 * Nằm ở CÔNG TY GIỮ, không phải người lao động tự khai. Nhân viên sửa được những ô này thì
 * họ tự xoá trắng «Hợp đồng hết hạn» hoặc tự đặt «Đã nghỉ» — và thẻ «Hợp đồng sắp hết hạn»
 * của Giám đốc TẮT THEO, im lặng. Đó là cảnh báo về giấy tờ lao động, không phải mục chính
 * chủ tự quản.
 */
export const EMPLOYEE_PROFILE_COMPANY_FIELDS = [
    'joinedOn',
    'jobTitle',
    'contractType',
    'contractEndDate',
    'employmentStatus',
];
/** '' = chưa khai. */
export const GENDERS = ['male', 'female', 'other'];
/** '' = chưa khai. */
export const CONTRACT_TYPES = [
    'probation',
    'fixed-term',
    'indefinite',
    'seasonal',
    'collaborator',
];
/** Ô DUY NHẤT bắt buộc có giá trị — không có lựa chọn «chưa khai». */
export const EMPLOYMENT_STATUSES = ['active', 'resigned'];
/** Mỗi ô một dòng chữ, không phải chỗ dán cả trang văn bản. */
export const EMPLOYEE_PROFILE_MAX_FIELD_LENGTH = 200;
export const EMPLOYEE_PROFILE_MAX_NOTES_LENGTH = 2000;
export const employeeProfileParamsSchema = z.object({
    username: z.string().min(1).max(200),
});
/** `null` được hiểu như '' (xoá trắng ô). Ô VẮNG MẶT = giữ nguyên giá trị đang lưu. */
const fieldValueSchema = z.string().nullable().optional();
/**
 * Thân của `PATCH /employee-profiles/:username`: chỉ gửi những ô muốn đổi. Schema CỐ Ý lỏng
 * (không giới hạn độ dài, không enum): từng ô do máy chủ kiểm theo thứ tự và trả đúng câu báo
 * tiếng Việt của hệ thống cũ — xem `profiles.rules.ts`. Khoá lạ bị bỏ qua.
 */
export const saveEmployeeProfileRequestSchema = z.object(Object.fromEntries(EMPLOYEE_PROFILE_FIELDS.map((field) => [field, fieldValueSchema])));
//# sourceMappingURL=profiles.js.map